import { ApiConsoleUserRole } from "apps/console/modules/user/list/types";
import { ParticipantRole } from "shared/enums/ParticipantRole";
import LanguageType from "../../enums/LanguageType";

export enum Action {
  USER_LOGIN = "USER_LOGIN",
  USER_LOGOUT = "USER_LOGOUT",
  SAVE_USER_DETAIL = "SAVE_USER_DETAIL"
}

interface AuthState {
  token?: string;
  userDetail?: AdminConsoleLoginResponse;
}

type AuthActionType =
  | { type: Action.USER_LOGIN; payload: string }
  | { type: Action.USER_LOGOUT }
  | { type: Action.SAVE_USER_DETAIL; payload?: AdminConsoleLoginResponse };

interface AuthContextType {
  token?: string;
  userDetail?: AdminConsoleLoginResponse;
  isLoggedIn: Function;
  login: Function;
  logout: (callback?: () => void) => Promise<void>;
  getSelectedLanguage: () => LanguageType;
}

interface AuthDispatchInterface {
  loginAction: (payload: string) => void;
  logoutAction: () => void;
  saveUserDetailAction: (payload?: AdminConsoleLoginResponse) => void;
}

export interface AdminConsoleLoginResponse {
  id: string;
  userCode: any;
  firstName: string;
  lastName: string;
  email: string;
  clientId: any;
  registrationId: any;
  platformUser: boolean;
  eventSeriesUser: boolean;
  platformId: any;
  consoleUser?: boolean;
  participantRoles: Array<ParticipantRole>;
  consoleUserRoles: Array<ApiConsoleUserRole>;
}
